import {Skeleton} from '@gwc/core'
import {Lead, ListItemProps, Slot, Text} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './SlotSkeleton.classes'

export type AddressSkeletonProps = ListItemProps<'div'> & {disableLead?: boolean}

export const SlotSkeleton = memo(
  ({disableLead, ...props}: AddressSkeletonProps): React.ReactElement => (
    <Slot className={classes.slotWrapper} {...props}>
      {!disableLead && (
        <Lead>
          <Skeleton className={classes.lead} />
        </Lead>
      )}
      <Text className={classes.text}>
        <Skeleton className={classes.content} />
      </Text>
    </Slot>
  ),
)
